import * as angular from "angular";
import './newsfeed-data-table.component.css'

const newsfeedsDataTableConfig = {
    template: `
        <mw-table class="mw-outputs-data-table">
            <header class="mw-table__header" ng-class="[{'mw-table__header--selected-items': $ctrl.selectedItems.length}]">
                <!-- default toolbar -->
                <mw-collection-header
                    ng-if="$ctrl.showHeader()"
                    is-search-active="$ctrl.NewsfeedsService.isSearchVisible"
                    is-header-title-visible="$ctrl.isHeaderTitleVisible()"
                    on-search="$ctrl.search($event)"
                    search-input-placeholder="{{$ctrl.$translate.instant('mw-newsfeed-data-table__search-placeholder')}}"
                    on-search-toggle="$ctrl.onSearchToggle($event)" collection-type="table">

                    <mw-collection-header-title>
                        <span class="mw-collection-header__title" ng-if="$ctrl.isHeaderTitleVisible()" translate>Newsfeeds</span>
                    </mw-collection-header-title>
                    <mw-collection-header-actions>
                        <md-menu
                            class="mw-menu"
                            md-position-mode="target-right target"
                            md-offset="0 50">

                            <mw-menu-trigger-icon-button
                                icon='content:ic_sort_24px'
                                tooltip="{{'mw-newsfeed-data-table__sort-tooltip' | translate}}"
                                on-click='$mdOpenMenu($event)'></mw-menu-trigger-icon-button>

                            <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                                <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
                                <mw-menu-item
                                    type="singleselect"
                                    ng-repeat="orderBy in $ctrl.NewsfeedsService.orderByOptions"
                                    is-selected="orderBy === $ctrl.NewsfeedsService.orderBy"
                                    on-click="$ctrl.setOrderBy(orderBy)">

                                    {{$ctrl.$translate.instant('mw-newsfeed-data-table__order-by-' + orderBy)}}
                                </mw-menu-item>
                                <md-divider class="mw-menu-divider"></md-divider>
                                <mw-menu-item
                                    type="singleselect"
                                    ng-repeat="sortOrder in $ctrl.NewsfeedsService.sortOrderOptions"
                                    is-selected="sortOrder === $ctrl.NewsfeedsService.sortOrder"
                                    on-click="$ctrl.setSortOrder(sortOrder)">

                                    {{$ctrl.$translate.instant('mw-newsfeed-data-table__sort-' + sortOrder.toLowerCase() + 'ending')}}
                                </mw-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </mw-collection-header-actions>
                </mw-collection-header>
                <!-- selected items toolbar -->
                <mw-collection-bulk-action
                    ng-if="$ctrl.selectedItems.length"
                    selected-items="$ctrl.selectedItems" on-reset-selected-items="$ctrl.resetSelectedItems($event)">
                    <md-button
                        ng-click="$ctrl.showNewsFeedLinks($ctrl.selectedItems, $event)"
                        ng-if="$ctrl.selectedItems.length === 1 && $ctrl.permissions"
                        class="md-icon-button" aria-label="{{::'mw-newsfeed-data-table__action-show-links' | translate}}">

                        <md-tooltip md-delay="500">
                            <span translate>mw-newsfeed-data-table__action-show-links</span>
                        </md-tooltip>
                        <md-icon md-svg-icon="content:ic_link_24px">show links</md-icon>
                    </md-button>
                    <md-button
                        ng-click="$ctrl.moderateArticles($ctrl.selectedItems[0])"
                        ng-if="$ctrl.selectedItems.length === 1"
                        class="md-icon-button"
                        aria-label="{{::'mw-newsfeed-data-table__action-moderate' | translate}}">

                        <md-tooltip md-delay="500">
                            <span translate>mw-newsfeed-data-table__action-moderate</span>
                        </md-tooltip>
                        <md-icon md-svg-icon="av:ic_playlist_add_24px">moderate</md-icon>
                   </md-button>
                   <md-button
                       ng-click="$ctrl.editDetails($ctrl.selectedItems[0])"
                       ng-if="$ctrl.selectedItems.length === 1 && $ctrl.permissions"
                       class="md-icon-button" aria-label="{{::'Edit Selected Items' | translate}}">

                        <md-tooltip md-delay="500">
                            <span translate>mw-newsfeed-data-table__action-edit</span>
                        </md-tooltip>
                        <md-icon md-svg-icon="editor:ic_mode_edit_24px">edit</md-icon>
                    </md-button>
                    <md-button
                        ng-click="$ctrl.deleteNewsfeeds($ctrl.selectedItems, $event)"
                        ng-if="$ctrl.selectedItems.length === 1 && $ctrl.permissions"
                        class="md-icon-button" aria-label="{{::'Delete Selected Items' | translate}}">

                        <md-tooltip md-delay="500">
                            <span translate>mw-newsfeed-data-table__action-delete</span>
                        </md-tooltip>
                        <md-icon md-svg-icon="action:ic_delete_24px">delete</md-icon>
                    </md-button>
                </mw-collection-bulk-action>
            </header>
                <md-card ng-if="!($ctrl.NewsfeedsService.filteredItems.length === 0)">
                    <md-table-container>
                        <table
                            class="mw-table--actions-visible"
                            md-table md-progress="$ctrl.NewsfeedsService.loadPagePromise"
                            md-row-select="true" ng-model="$ctrl.selectedItems">

                            <thead md-head md-order="$ctrl.orderBy" md-on-reorder="$ctrl.onReorder">
                                <tr md-row>
                                    <th class="mw-table__text-column mw-table__greedy-column"" md-column md-order-by="name">
                                        <span translate>mw-newsfeed-data-table__column-header-name</span>
                                    </th>
                                    <th class="mw-table__text-column" md-column md-order-by="feedType" hide-xs>
                                        <span translate>mw-newsfeed-data-table__column-header-type</span>
                                    </th>
                                    <th class="mw-table__text-column" md-column md-order-by="created" hide-xs hide-sm>
                                        <span translate>mw-newsfeed-data-table__column-header-created-by</span>
                                    </th>
                                    <th class="mw-table__date-column" md-column md-order-by="modified" hide-xs>
                                        <span translate>mw-newsfeed-data-table__column-header-modified</span>
                                    </th>
                                    <th class="mw-table__actions-column"></th>
                                </tr>
                            </thead>
                            <tbody md-body>
                                <tr md-row
                                    ng-click="$ctrl.moderateArticles(item)"
                                    ng-repeat="item in $ctrl.NewsfeedsService.filteredItems |  orderBy: $ctrl.NewsfeedsService.orderBy: $ctrl.NewsfeedsService.sortOrder === 'DESC' | limitTo: $ctrl.NewsfeedsService.paging.itemsPerPage: ($ctrl.NewsfeedsService.paging.selectedPage - 1) * $ctrl.NewsfeedsService.paging.itemsPerPage track by item._id"
                                    md-select="item" md-select-id="_id"
                                    md-auto-select="false"
                                    id="{{item._id}}">

                                    <td class="mw-table__text-column mw-table__greedy-column"" md-cell>{{item.name}}</td>
                                    <td class="mw-table__text-column" md-cell hide-xs>{{::item.feedType}}</td>
                                    <td class="mw-table__text-column" md-cell hide-xs hide-sm>{{::item.created}}</td>
                                    <td class="mw-table__date-column" md-cell hide-xs>{{$ctrl.formatDate(item.modified)}}</td>
                                    <td class="mw-table__actions-column" md-cell>
                                        <md-menu
                                            class="mw-menu"
                                            md-position-mode="target-right target"
                                            md-offset="0 50"
                                            ng-style="{'visibility': $ctrl.selectedItems.length === 0 ? 'visible' : 'hidden'}">

                                            <mw-menu-trigger-icon-button
                                                icon="navigation:ic_more_vert_24px"
                                                tooltip="{{::'mw-collection__tooltip-menu-trigger' | translate}}"
                                                on-click="$mdOpenMenu($event)">
                                            </mw-menu-trigger-icon-button>

                                            <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                                                <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
                                                <mw-menu-item
                                                    icon="content:ic_link_24px"
                                                    aria-label="{{::'mw-newsfeed-data-table__action-show-links' | translate}}"
                                                    ng-click="$ctrl.showNewsFeedLinks([item])">

                                                    {{::$ctrl.$translate.instant('mw-newsfeed-data-table__action-show-links')}}
                                                </mw-menu-item>
                                                <mw-menu-item
                                                    icon="av:ic_playlist_add_24px"
                                                    aria-label="{{::'mw-newsfeed-data-table__action-moderate' | translate}}"
                                                    ng-click="$ctrl.moderateArticles(item)">

                                                    {{::$ctrl.$translate.instant('mw-newsfeed-data-table__action-moderate')}}
                                                </mw-menu-item>
                                                <mw-menu-item
                                                    icon="meltwater:edit"
                                                    aria-label="{{::'Edit' | translate}}"
                                                    ng-click="$ctrl.editDetails(item)">

                                                    {{::$ctrl.$translate.instant('Edit')}}
                                                </mw-menu-item>
                                                <mw-menu-item
                                                    icon="action:ic_delete_24px"
                                                    aria-label="{{::'Delete' | translate}}"
                                                    ng-click="$ctrl.deleteNewsfeeds([item], $event)">

                                                    {{::$ctrl.$translate.instant('Delete')}}
                                                </mw-menu-item>
                                            </md-menu-content>
                                        </md-menu>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </md-table-container>
                    <md-table-pagination
                        md-limit="$ctrl.NewsfeedsService.paging.itemsPerPage"
                        md-page="$ctrl.NewsfeedsService.paging.selectedPage"
                        md-total="{{$ctrl.NewsfeedsService.paging.totalItems}}"
                        md-on-paginate="$ctrl.onPage" md-label="{of: 'of'}"></md-table-pagination>
            </md-card>
            <md-card ng-if="$ctrl.NewsfeedsService.searchText && $ctrl.NewsfeedsService.filteredItems.length === 0">
                 <md-card-content class="mw-empty-state-container">
                     <mw-empty-state text="{{$ctrl.translatedEmptySearchResultsText}}"></mw-empty-state>
                 </md-card-content>
            </md-card>
            <md-card class="mw-empty-state__wrapper" ng-if="$ctrl.NewsfeedsService.filteredItems.length === 0 && !$ctrl.isLoading && !$ctrl.NewsfeedsService.searchText">
                <md-card-content class="mw-empty-state-container">
                    <mw-empty-state text={{$ctrl.$translate.instant('newsfeeds__no-results-label')}} sub-text={{$ctrl.$translate.instant('mw-collection__empty-state-subtext--create-new')}}></mw-empty-state>
                </md-card-content>
            </md-card>
        </mw-table>
    `,
    selector: 'mwNewsfeedDataTable',
    controller: null
};

class NewsfeedDataTableComponent {
    selectedItems: Array<string>;
    permissions: boolean;
    translatedEmptySearchResultsText: string;
    orderBy: any;
    isLoading: boolean;

    constructor(
        private $window,
        private $mdMedia,
        private $mdDialog,
        private $filter,
        private NewsfeedsService,
        private $location,
        private $translate,
        private $mdToast,
        private OutputConfig,
        private AnalyticsService
    ) {
        'ngInject';
        this.selectedItems = [];
        this.isLoading = true;

        this.permissions = false;
        // Unfortunately, the md-data-table component does not execute these event handlers with the controller being the
        // context, we need to force it as the context by using angular.bind.
        this.onPage = angular.bind(this, this.onPage);
        this.onReorder = angular.bind(this, this.onReorder);
    }

    $onInit() {
        this.NewsfeedsService.getNewsfeedPermissions().then((permissions) => {
            this.permissions = permissions;
            this.syncOrderBy();

            this.isLoading = true;
            this.NewsfeedsService.load()
                .finally(() => this.isLoading = false);
        });
    }

    $onDestroy(){
        this.NewsfeedsService.clear();
    }

    showHeader(){
        if(this.selectedItems.length){
            return false
        } else if(this.NewsfeedsService.filteredItems.length > 0 || this.NewsfeedsService.searchText){
            return true;
        } else if (this.NewsfeedsService.filteredItems.length === 0) {
            return false;
        } else {
            return true;
        }
    }

    showNewsFeedLinks(selectedItems, event){
        var linkUrl = selectedItems[0].links[0].href,
            isRSS = (selectedItems[0].type === 'RSS Feed') ? true : false,
            isLegacy = (selectedItems[0].typeData && selectedItems[0].typeData.legacyTemplate && selectedItems[0].typeData.legacyTemplate.trim()) ? true : false,
            links = {
                rsslink: linkUrl + (isRSS ? '&type=rss' : '.rss'),
                xmllink: linkUrl + (isRSS ? '&type=xml' : '.xml'),
                htmllink: isLegacy ? linkUrl + (isRSS ? '&type=html' : '') : null,
            };

        this.$mdDialog.show({
            autoWrap: false,
            bindToController: true,
            targetEvent: event,
            locals: {
                links: links
            },
            template: `<md-dialog class="mw-mini-modal mw-mini-modal--wide mw-mini-modal--auto-height" aria-label="Show Links" layout="column">
                <show-links-dialog class="mw-mini-modal-wrapper show-links-dialog" links="$ctrl.links" layout="column" flex></show-links-dialog>
            </md-dialog>
            `,
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl'
        }).then();

    };

    isHeaderTitleVisible() {
        return !(this.$mdMedia('xs') && this.NewsfeedsService.isSearchVisible);
    }

    editDetails(item, event) {
        this.AnalyticsService.editOutputMgr(item);
        this.$location.url('/outputs/newsfeeds/edit/' + item._id + '?stepNum=0');
    };

    moderateArticles(item, event) {
        this.AnalyticsService.showModerateOutputMgr(item);
        this.$location.url('/outputs/newsfeeds/moderate/' + item._id );
    };

    deleteNewsfeeds(selectedItems, event){
        let me =this;
        var deleteDialog = this.$mdDialog.confirm()
            .title(me.$translate.instant('newsfeeds-delete__delete-confirmation-title'))
            .textContent(me.$translate.instant('newsfeeds-delete__delete-confirmation-message',{
                name: selectedItems[0].name,
                type: 'newsfeed'
            }))
            .ok(me.$translate.instant('action-label__delete'))
            .cancel(me.$translate.instant('action-label__cancel'))
            .targetEvent(event),
            deleteSuccessMessage = this.$mdToast.simple().textContent(this.$translate.instant('Output was deleted')),
            deleteFailedMessage = this.$mdToast.simple().textContent(this.$translate.instant('Something has gone wrong behind the scenes. Please try again later.')).highlightClass('md-warn');

        this.$mdDialog.show(deleteDialog).then(
            ()=> {
                this.NewsfeedsService.deleteNewsfeed(selectedItems[0]).then((response)=>{
                    this.AnalyticsService.deleteOutputMgr(selectedItems[0]);

                    this.$mdToast.show(deleteSuccessMessage);
                    this.selectedItems = [];

                },(error)=>{
                    this.$mdToast.show(deleteFailedMessage);
                })
            },
            function cancelHandler() {

            }
        );
    };


    search(searchText) {
        this.NewsfeedsService.searchText = searchText;
        this.NewsfeedsService.filterNewsfeeds(searchText);
        this.translatedEmptySearchResultsText = this.$translate.instant(
            'mw-newsfeeds--search-empty-state__text' ,
            {searchText: '"' + this.NewsfeedsService.searchText + '"'}
        );
    };

    onSearchToggle(isSearchActive) {
        this.NewsfeedsService.searchText = '';
        this.NewsfeedsService.isSearchVisible = isSearchActive;
    };

    resetSelectedItems(event) {
        this.selectedItems = [];
    };

    onPage(page, limit) {
        this.resetTableScroll();
    }

    resetTableScroll() {
        var element = this.$window.document.getElementById('mw-newsfeeds-table__content');
        if (element) {
            element.scrollTop = 0;
        }
    }

    openSortMenu($mdOpenMenu, event) {
        $mdOpenMenu(event);
    }


    onReorder(order) {
        var sortOrder = 'ASC';

        if (order.substr(0, 1) === '-') {
            sortOrder = 'DESC';
            order = order.substring(1);
        }

        this.NewsfeedsService.orderBy = order;
        this.NewsfeedsService.sortOrder = sortOrder;
        this.NewsfeedsService.paging.selectedPage = 1;
    }

    setOrderBy(orderBy) {
        if (this.NewsfeedsService.orderBy !== orderBy) {
            this.NewsfeedsService.orderBy = orderBy;
            this.syncOrderBy();
        }
    }

    setSortOrder(sortOrder) {
        if (this.NewsfeedsService.sortOrder !== sortOrder) {
            this.NewsfeedsService.sortOrder = sortOrder;
            this.syncOrderBy();

            this.isLoading = true;
            this.NewsfeedsService.load()
                .finally(() => this.isLoading = false);
        }
    }

    syncOrderBy() {
        var orderBy = this.NewsfeedsService.orderBy;
        if (this.NewsfeedsService.sortOrder === 'DESC') {
            orderBy = '-' + orderBy;
        }

        this.orderBy = orderBy;
    }

    formatDate(date){
        return this.$filter('mwConvertDateToUserTimezone')(date, this.OutputConfig.OUTPUT_DATE_FORMAT);
    }
}

newsfeedsDataTableConfig.controller = NewsfeedDataTableComponent;

export {
    newsfeedsDataTableConfig,
    NewsfeedDataTableComponent as default
};



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsfeeds/newsfeed-data-table/newsfeed-data-table.component.ts
 **/